import { render, staticRenderFns } from "./organization.vue?vue&type=template&id=f32bfd4e&scoped=true&"
import script from "./organization.vue?vue&type=script&lang=js&"
export * from "./organization.vue?vue&type=script&lang=js&"
import style0 from "./organization.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./organization.vue?vue&type=style&index=1&id=f32bfd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32bfd4e",
  null
  
)

export default component.exports